module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-basket/boxoffice-basket.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-basket/boxoffice-basket.component.scss
// module chunks = 9